import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getLocations as getLocationsAPI } from 'src/common/Scraper';

export interface GBPKeyword {
  id: number;
  name: string;
}

export interface GBPLocation {
  name: string; // E.g., "locations/1234567890"
  title: string; // E.g., "Business Name"
  accountId: string; // E.g., "accounts/1234567890"
  address: string | null;
  createdTime: number;
  websiteUri: string | null;
  selected: boolean;
  reportId?: number | null;
  locationId?: number | null;
  keywords?: GBPKeyword[];
  progressing?: boolean;
  isConnectedWithSqsp?: boolean;
  usedAddonCredit?: boolean;
  temp?: boolean;
  [key: string]: any;
}

export interface GBPLocationsResponse {
  status: string;
  message: string;
  isGBPConnected: boolean;
  locations?: GBPLocation[];
  isSqSpDisconnected?: boolean;
  limitExceeded?: boolean;
  [key: string]: any;
}

export interface GetGBPLocationsPayload {
  isConnecting?: boolean;
  selectedAccountId?: string | null;
  squareSpaceSiteId?: string | null;
}

interface UseGetGBPLocationsOptions {
  /** Whether the query should be enabled. Defaults to true. */
  enabled?: boolean;
}

/**
 * React Query hook to fetch GBP locations using getLocations API.
 *
 * @param payload - Payload containing isConnecting, selectedAccountId, and squareSpaceSiteId
 * @param options - Optional query configuration (enabled)
 */
export const useGetGBPLocations = (
  payload: GetGBPLocationsPayload = {},
  options: UseGetGBPLocationsOptions = {}
): UseQueryResult<GBPLocationsResponse, Error> => {
  const { enabled = true } = options;

  return useQuery<GBPLocationsResponse, Error>({
    queryKey: ['getGBPLocations', payload],
    queryFn: () => getLocationsAPI(payload) as Promise<GBPLocationsResponse>,
    enabled,
  });
};

export default useGetGBPLocations;
